import {
    VISIBLE,
} from 'src/constants/appConstants';

// Utility function for procedureBtnClickHandler logic
export default function procedureBtnClickHandlerUtil({
    procedureTypeUsageVisibility,
    proceduresList,
    dispatch,
    getDropdownOptionsRequest,
    procedureInfoDetails,
    usageDetails,
    salesOrg,
    setProcedureDropdownValue,
    getProcedureInfoRequest,
    replenGridData,
    setIsProcedureBtnClicked,
    setShowCancelPopUp,
    navigateToProcedureScreen,
    replenishmentPageVisibilityUsage,
    replenishBtnClickHandler
}) {
     if (!replenishmentPageVisibilityUsage) {
            replenishBtnClickHandler();
        }
        else {
            if (
                !(
                    procedureTypeUsageVisibility === VISIBLE &&
                    proceduresList?.length > 0
                )
            ) {
                dispatch(getDropdownOptionsRequest('procedures'));
            }
            if (
                !(
                    procedureInfoDetails &&
                    Object.keys(procedureInfoDetails).length > 0
                )
            ) {
                // countryCode !== COUNTRY_CODE_JAPN && countryCode !== undefined
                //     ?
                const data = {
                    procedureCode:
                        procedureTypeUsageVisibility === VISIBLE &&
                            usageDetails?.procedureCode
                            ? usageDetails?.procedureCode
                            : '',
                    salesOrg: salesOrg,
                };
                setProcedureDropdownValue({
                    procedureCode: usageDetails?.procedureCode,
                    procedureDescription: usageDetails?.procedureDescription,

                });
                dispatch(getProcedureInfoRequest('Usage', data));
                // : null;
            }
            if (
                replenGridData.some(
                    (data) =>
                        data.isSelected &&
                        !data.shippingDetails &&
                        !data.accountOwned
                )
            ) {
                setIsProcedureBtnClicked(true);
                setShowCancelPopUp(true);
            } else {
                navigateToProcedureScreen();
            }
        }
}
